export default __webpack_public_path__ + "690f2bb028e6df1f3d22bdb5191e118c.png";